import styled from 'styled-components';
import { MOBILE_SCREEN_MEDIA_QUERY } from './fdr-image-text-component.constants';

export const FdrImageTextComponentWrapper = styled.div<{
  bgColor: string;
}>(({ bgColor }) => ({
  backgroundColor: bgColor ? bgColor : 'transparent',
  width: '100%',
}));

export const FdrImageTextComponentContainer = styled.div<{
  imagePlacement: string;
  fontColor: string;
  componentWidth: string;
}>(
  ({
    theme: { space, colors },
    imagePlacement,
    fontColor,
    componentWidth,
  }) => ({
    color: fontColor ? fontColor : colors.black,
    display: 'flex',
    marginLeft: 'auto',
    marginRight: 'auto',
    maxWidth: componentWidth === 'LARGE' ? '1440px' : '858px',
    justifyContent: 'center',
    flexDirection: imagePlacement !== 'RIGHT' ? `row` : `row-reverse`,
    alignItems: 'start',
    gap: '20px',
    paddingLeft: '20px',
    paddingRight: '20px',
    paddingBottom: space[9],
    paddingTop: space[9],
    '&.small-padding-bottom': {
      paddingBottom: '40px',
    },
    '&.small-padding-top': {
      paddingTop: '40px',
    },
    '&.none-padding-bottom': {
      paddingBottom: space[0],
      '.text-block-text > *:last-child': {
        marginBottom: space[0],
      },
    },
    '&.none-padding-top': {
      paddingTop: space[0],
    },
    '.image': {
      flex: 1,
      flexShrink: 0,
      img: {
        maxHeight: '100%',
        maxWidth: '100%',
        width: '100%',
      },
    },
    [MOBILE_SCREEN_MEDIA_QUERY]: {
      alignItems: 'initial',
      flexDirection: 'column',
      paddingLeft: space[3],
      paddingRight: space[3],
      paddingBottom: '50px',
      paddingTop: '50px',
      '&.small-padding-bottom': {
        paddingBottom: space[4],
      },
      '&.small-padding-top': {
        paddingTop: space[4],
      },
      '&.none-padding-bottom': {
        paddingBottom: space[0],
        '.text > *:last-child': {
          marginBottom: space[0],
        },
      },
      '&.none-padding-top': {
        paddingTop: space[0],
      },
    },
  })
);

export const FdrTextWrapper = styled.div(
  ({ theme: { space, text, fontSizes } }) => ({
    flex: '1',
    '.text': {
      ...text.richText,
      flex: 1,
      flexShrink: 0,
      h3: {
        fontSize: '30px',
        lineHeight: '42px',
        [MOBILE_SCREEN_MEDIA_QUERY]: {
          fontSize: fontSizes[5],
          lineHeight: '38px',
        },
      },
      h4: {
        fontSize: fontSizes[4],
        lineHeight: '28px',
      },
    },
    '.title': {
      fontSize: '46px',
      lineHeight: '60px',
      paddingTop: space[3],
      marginBottom: space[3],
      [MOBILE_SCREEN_MEDIA_QUERY]: {
        fontSize: fontSizes[7],
        lineHeight: '42px',
      },
    },
  })
);
